export default {
  rewards: {
    title: "Mga Gantimpala",
    claim: "Kunin",
    weeklyCashback: "Lingguhang Cashback",
    weeklyCashbackDesc: "Ibalik ang bahagi ng iyong lingguhang pagkalugi kada linggo.",
    dailySpin: "Araw-araw na Pag-ikot",
    dailySpinDesc: "Ikot ang gulong araw-araw para may pagkakataon manalo ng malaking premyo.",
    invitationBonus: "Bonus sa Pag-imbita",
    invitationBonusDesc: "Mag-imbita ng mga kaibigan at kumita ng gantimpala para sa bawat sasali.",
    rebate: "Rebate",
    rebateDesc: "Kumita ng rebate sa bawat taya, panalo man o talo.",
    bannerTitle: "MGA GANTIMPALA",
    bannerSubtitle: "Kumpletuhin ang mga gawain at kumita ng magagandang gantimpala!",
    sectionTitle: "Iyong Kahanga-hangang Gantimpala",
    goNow: "Pumunta na",
    historyReceived: "Kabuuang natanggap",
    todayReceived: "Natanggap ngayon",
    cashbackDialog: {
      title: "Bet Cashback",
      loading: "Naglo-load...",
      empty: "Walang cashback rules",
      level: "Antas",
      amountRange: "Saklaw ng Halaga",
      rewardRate: "Rate ng Reward",
      rewardCap: "Limitasyon ng Reward",
    },
    cards: {
      checkin: {
        title: "Araw-araw na Check-in",
        subtitle: "Mag-log in para makapag-check-in araw-araw",
        description: "Mga manlalaro, huwag kalimutan mag-check-in araw-araw~",
      },
      cashback: {
        title: "Cashback",
        subtitle: "Mga gantimpala ng rebate ng platform",
      },
      rescue: {
        title: "Bonus sa Pagsagip",
        subtitle: "Maglaro ng 3 cash games",
        description: "Pondo ng pagsagip para sa mga nabangkarote na manlalaro",
      },
      task: {
        title: "Mga Gawain",
        subtitle: "Kumpletuhin ang mga gawain ng platform",
        description: "Mga gawain ng platform",
      },
      balance: {
        title: "Vault",
        subtitle: "Kumita ng araw-araw na interes",
        description: "Vault ng platform",
      },
      loan: {
        title: "Bonus sa Pautang",
        subtitle: "Madaling manghiram",
        description: "Pautang ng platform",
      },
    },
    checkIn: {
      dailySignIn: "ARAW-ARAW NA CHECK-IN",
      totalRewards: "KABUUANG GANTIMPALA",
      headlineDaysBefore: "Mag-check-in ng",
      headlineDaysAfter: "araw,",
      headlineTailCumulative: "okay lang kung makaligtaan ang isang araw.",
      headlineTailDate: "ang pagkalaktaw ng isang araw ay mawawalan ng gantimpala ng araw na iyon.",
      headlineCumulative: "Mag-check-in ng {days} araw para manalo ng malaki, okay lang kung makaligtaan ang isang araw.",
      headlineDate: "Mag-check-in ng {days} araw, ang pagkalaktaw ng isang araw ay mawawalan ng gantimpala.",
      headlineEmpty: "Mag-check-in para manalo ng gantimpala",
      title: "Check-in",
      modeCumulative: "Cumulative Check-in",
      modeDate: "Check-in Ayon sa Petsa",
      rewards: "Mga Gantimpala",
      signedIn: "Naka-check-in na",
      day: "Araw {n}",
      loading: "Naglo-load...",
      empty: "Walang aktibong aktibidad ng check-in.",
      btnCheckIn: "Check-in",
      btnSigned: "Naka-check-in",
      btnLocked: "Naka-lock",
      claimSuccess: "Matagumpay na check-in, gantimpala {amount} {currency} naikredito",
      claimFailed: "Nabigo ang check-in",
      alreadySigned: "Naka-check-in ka na ngayong araw",
      notLogin: "Mangyaring mag-log in muna",
    },
  },
};
